import React, { Component } from "react";
import Content from "../../content/Content";

export default class Article extends Component {
  render() {
    return (
      <React.Fragment>
        <Content name={this.props.header} />
        {this.props.body && <Content name={this.props.body} />}
      </React.Fragment>
    );
  }
}
